import React from "react";
import { PhoneIcon } from "lucide-react";
export function MobileConversionBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-[0.9fr_1.1fr] border-t border-line bg-white p-2 shadow-[0_-8px_30px_rgba(0,0,0,0.12)] md:hidden" data-id="element-123" data-mp="2r5uu48cm7u0g">
      <a href="tel:+61892283555" className="flex h-12 items-center justify-center gap-2 rounded-md text-sm font-bold text-ink" aria-label="Call Perth Home Air Conditioning on 08 9228 3555" data-id="element-124" data-mp="2dc3xg0jzg4m5">
        <PhoneIcon className="h-4 w-4" data-id="element-125" data-mp="23hv63g6ouhpk" /> CALL NOW
      </a>
      <a href="#quote" className="flex h-12 items-center justify-center rounded-md bg-rinnai px-3 text-sm font-bold text-white" data-id="element-126" data-mp="28fwodywaiczz">
        GET RINNAI QUOTE
      </a>
    </div>;
}